export default __webpack_public_path__ + "67bd9c7fa937912caf4331359d1d61eb.svg";